import * as React from 'react';

import { styled } from '@mui/material/styles';
import MuiChip, { ChipProps } from '@mui/material/Chip';

export default styled((props: ChipProps) => <MuiChip {...props} label={props.label ? `+${props.label}` : props.label} />)(() => ({
  '& .MuiChip-label': { unicodeBidi: 'plaintext' },
}));
